import React, { ErrorInfo } from 'react';
import { Button } from 'react-bootstrap';

interface ErrorBoundaryProps {
  errorMessage?: (clear: () => void) => JSX.Element;
}

interface ErrorBoundaryState {
  hasError: boolean;
}

export class ErrorBoundary extends React.Component<
  React.PropsWithChildren<ErrorBoundaryProps>,
  ErrorBoundaryState
> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    // You can also log the error to an error reporting service
    console.error(error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI

      if (this.props.errorMessage)
        return <>{this.props.errorMessage(() => this.setState({ hasError: false }))}</>;

      return (
        <div className={'text-center'}>
          <h3>Something went wrong.</h3>
        </div>
      );
    }

    return this.props.children;
  }
}

export const errorBoundaryReloadMessage = (onReload: () => void) => (clear: () => void) => (
  <div className={'text-center mt-5'}>
    <h5>Oops! An error occurred.</h5>
    <Button
      variant={'warning'}
      onClick={() => {
        onReload();
        clear();
      }}
    >
      Reload
    </Button>
  </div>
);
